"use client";

import { cn } from "@/lib/utils";
import { InputHTMLAttributes, ReactNode, useState, forwardRef } from "react";

interface Props extends InputHTMLAttributes<HTMLTextAreaElement> {
  icon: ReactNode;
  placeholder: string;
  id: string;
  error?: boolean;
  errorMessage?: string;
  focusDisabled?: boolean
  rows?: number;
}

const TextArea = forwardRef<HTMLTextAreaElement, Props>((props, ref) => {
  // Only real textarea attributes may reach the DOM; the rest would render as
  // attribute strings like icon="[object Object]".
  const {
    icon,
    error,
    errorMessage,
    focusDisabled = false,
    className,
    ...textareaProps
  } = props;

  const [shadow, setShadow] = useState(false);

  return (
    <div className="w-full rounded-3xl">
      <div
        onClick={() => {
          if (focusDisabled) return;

          document.getElementById(props.id)?.focus()
        }}
        className={cn(
          `w-full py-2 px-4 rounded-[24px] flex gap-2 border border-assistant-secondary bg-white duration-200 ${error ? "border-secondary" : "border-slate-300"}`,
          shadow && "shadow-lg",
        )}
      >
        <div className="p-2 text-assistant">{icon}</div>

        <textarea
          {...textareaProps}
          ref={ref}
          id={props.id}
          placeholder={props.placeholder}
          onFocus={() => setShadow(true)}
          onBlur={() => setShadow(false)}
          className={cn("py-2 w-full text-sm font-bold max-h-[168px] outline-none h-10 resize-none text-assistant placeholder:text-assistant", className)}
        />
      </div>

      {error && (
        <div className="text-secondary text-[12px] mt-1.5 pl-6">
          <span>{errorMessage}</span>
        </div>
      )}
    </div>
  );
});

TextArea.displayName = "TextArea";

export default TextArea;
